
const util = {};

util.createCookie = function (name, value, days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	}
	else var expires = "";
	document.cookie = name+"="+value+expires+"; path=/";
}

util.readCookie = function (name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

util.eraseCookie = function (name) {
	util.createCookie(name,"",-1);
}

util.capitalize = function (str) {
	return str.replace(
		/\w\S*/g,
		function(txt) {
			return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
		}
	);
}
util.isMobile = function() {
	var check = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	return check;
};

util.formatPrice = function(config, value, zero) {
    if (zero == '' && !value) {
        return '';
    } else if (!value) {
        value = 0;
    }
    var isNegative = false;
    if (value < 0) {
        isNegative = true;
        value = -value;
    }
    var val = '';
    if (config.Params.Currency == 'Euro') {
        val = (value / 1).toFixed(2).replace('.', ',');
        val =  '€' + (isNegative ? '(' : '') + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + (isNegative ? ')' : '');
    } else if (config.Params.Currency == 'Pound Sterling') {
        val = (value / 1).toFixed(2).replace(',', '.');
        val =  '£' + (isNegative ? '(' : '') + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (isNegative ? ')' : '');
    } else {
        val = (value / 1).toFixed(2).replace(',', '.');
        val =  '$' + (isNegative ? '(' : '')  + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (isNegative ? ')' : '');
    }
    return val;
}
util.currencySign = function(config) {

    if (config.Params.Currency == 'Euro') {
        return '€';
    } else if (config.Params.Currency == 'Pound Sterling') {
        return '£';
    } else {
        return '$';
    }
}
util.ordinal_suffix_of = function(i) {
    var j = i % 10;
    var k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}
util.nl2br = function (str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}
util.getPosition = function (elem) {
	var element = document.getElementById(elem);
	var Position = 0;

	while(element) {
		Position += (element.offsetTop - element.scrollTop + element.clientTop);
		element = element.offsetParent;
	}

	return Position;
}
util.scrollToClass = function (className) {
	// Get the first element with the given class name
	let el = this.$el.querySelector(className)
	// Get the bounding rectangle so we can get the element position position
	let rect = el.getBoundingClientRect()
	// Scroll to the element (using x and y axis)
	window.scrollTo(rect.left, rect.top)
}
util.makekey = function(length = 32) 
{
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
util.convertSportsTerm = function (config, termString) {
    termString = termString.replaceAll('MAINLOCATION_S_L',config.Params.mainlocationNames.toLowerCase());
	termString = termString.replaceAll('MAINLOCATION_L',config.Params.mainlocationName.toLowerCase());
    termString = termString.replaceAll('LOCATION_S_L',config.Params.locationNames.toLowerCase());
	termString = termString.replaceAll('LOCATION_L',config.Params.locationName.toLowerCase());
    termString = termString.replaceAll('PLAYINGSURFACE_S_L',config.Params.playingsurfaces.toLowerCase());
	termString = termString.replaceAll('PLAYINGSURFACE_L',config.Params.playingsurface.toLowerCase());
    termString = termString.replaceAll('PROGRAM_S_L',config.Params.programNames.toLowerCase());
	termString = termString.replaceAll('PROGRAM_L',config.Params.programName.toLowerCase());
    termString = termString.replaceAll('GAME_S_L',config.Params.games.toLowerCase());
	termString = termString.replaceAll('GAME_L',config.Params.game.toLowerCase());
    termString = termString.replaceAll('POINT_S_L',config.Params.points.toLowerCase());
	termString = termString.replaceAll('POINT_L',config.Params.point.toLowerCase());
    termString = termString.replaceAll('TIE_S_L',config.Params.ties.toLowerCase());
	termString = termString.replaceAll('TIE_L',config.Params.tie.toLowerCase());
    termString = termString.replaceAll('SCHEDULE_S_L',config.Params.schedules.toLowerCase());
	termString = termString.replaceAll('SCHEDULE_L',config.Params.schedule.toLowerCase());
    termString = termString.replaceAll('STANDING_S_L',config.Params.standings.toLowerCase());
	termString = termString.replaceAll('STANDING_L',config.Params.standing.toLowerCase());
    termString = termString.replaceAll('MAINLOCATION_S',config.Params.mainlocationNames);
	termString = termString.replaceAll('MAINLOCATION',config.Params.mainlocationName);
    termString = termString.replaceAll('LOCATION_S',config.Params.locationNames);
	termString = termString.replaceAll('LOCATION',config.Params.locationName);
    termString = termString.replaceAll('PLAYINGSURFACE_S',config.Params.playingsurfaces);
	termString = termString.replaceAll('PLAYINGSURFACE',config.Params.playingsurface);
    termString = termString.replaceAll('PROGRAM_S',config.Params.programNames);
	termString = termString.replaceAll('PROGRAM',config.Params.programName);
    termString = termString.replaceAll('GAME_S',config.Params.games);
	termString = termString.replaceAll('GAME',config.Params.game);
    termString = termString.replaceAll('POINT_S',config.Params.points);
	termString = termString.replaceAll('POINT',config.Params.point);
    termString = termString.replaceAll('TIE_S',config.Params.ties);
	termString = termString.replaceAll('TIE',config.Params.tie);
    termString = termString.replaceAll('SCHEDULE_S',config.Params.schedules);
	termString = termString.replaceAll('SCHEDULE',config.Params.schedule);
    termString = termString.replaceAll('STANDING_S',config.Params.standings);
	termString = termString.replaceAll('STANDING',config.Params.standing);


    return termString;
}
util.stripHtml = function(html)
{
   let tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || "";
}
export default util;
